export enum AccountType {
  PASSENGER = "passenger",
  EXECUTIVE_ASSISTANT = "executive_assistant",
  TRAVEL_MANAGER = "travel_manager",
  DRIVER = "driver",
  OPERATOR = "operator",
  USER_ACCOUNT = "user_account",
}
